<template>
  <div>
    <loading :active.sync="isLoading" 
    :can-cancel="true" 
    :on-cancel="onCancel"
    :is-full-page="fullPage"></loading>
    
    <h1>Dashboard</h1>

    <div class="row">
      <StretchCardComponent iconName="bullseye" :count="numOrdersToday" caption="Bestellungen heute" ></StretchCardComponent>
      <StretchCardComponent iconName="book" :count="sumOrderValueToday" caption="Rechnungsbetrag € heute" ></StretchCardComponent>

      <StretchCardComponent iconName="bullseye" :count="numOrdersCurrentMonth" caption="Bestellungen diesen Monat" ></StretchCardComponent>
      <StretchCardComponent iconName="book" :count="sumOrderValueCurrentMonth" caption="Rechnungsbetrag € diesen Monat" ></StretchCardComponent>
    </div>
    
    <div class="row" style="margin-top: 15px;">
        <div class="col-sm-1">Datum</div>
        <div class="col-sm-2">
            <input type="date" name="statDate" class="form-control form-control-sm" v-model="statDate">
        </div>
        <div class="col-sm-1">
            <button v-on:click="fetchData" class="btn btn-primary btn-sm">
                <font-awesome-icon icon="sync" />
                Refresh
            </button>
        </div>
    </div>


    <div class="card" style="margin-top: 15px;">
      <h5 class="card-title">Statistik - Tagesverlauf</h5>
      <div class="card-body">
        <DashboardDailyBarChart v-if="dailyLoaded"
                              :chart-data="realChartData"
                              :options="realChartOptions">
        </DashboardDailyBarChart>
      </div>
    </div>
  </div>
</template>

<script>
const request = require('superagent')
import Loading from 'vue-loading-overlay';
import DashboardDailyBarChart from './DashboardDailyBarChart'
import StretchCardComponent from './base/StretchCardCompoment'

export default{
  name: 'Dashboard',
  components: {
    Loading,
    DashboardDailyBarChart,
    StretchCardComponent
  },
  data() {
    return {chartData: [],
            isLoading: false,
            fullPage: true,
            api_token:"",
            dailyLoaded: false,
            statDate: "",
            numOrdersToday: 0,
            sumOrderValueToday: 0,
            numOrdersCurrentMonth: 0,
            sumOrderValueCurrentMonth: 0};
  },
  computed: {
    realChartOptions(){
        return  {
            responsive: true,
            maintainAspectRatio: false
        }
    },
    realChartData(){
        return {
                labels: this.chartData.labels,
                datasets: [
                    {
                        label: 'Bestellungen',
                        data: this.chartData.data_anzahl,
                        backgroundColor: 'green'
                    },
                    {
                        label: 'Betrag/Summe',
                        data: this.chartData.data_rechnungsbetrag,
                        backgroundColor: 'orange'
                    }
                    ]
                };
    }
  },
  mounted: function () {
    this.api_token = localStorage.getItem('API_TOKEN')
    this.fetchData();
  },
  methods: {
    onCancel(){},
    fetchData(){
    this.isLoading = true
    var that = this
    request
      .get(process.env.API_HOST + '/api/dashboard?stat_date='+this.statDate)
      .set('Accept', 'application/json')
      .set('Authorization', this.api_token)
      .then(function (res) {
        that.chartData = res.body.daily_data
        that.statDate = res.body.daily_data.date
        that.numOrdersToday = res.body.num_orders_today
        that.sumOrderValueToday = res.body.sum_order_value_today
        that.numOrdersCurrentMonth = res.body.num_orders_current_month
        that.sumOrderValueCurrentMonth = res.body.sum_order_value_current_month
            
        that.isLoading = false
        that.dailyLoaded = true
      })
    }
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Dashboard.vue